import { render, staticRenderFns } from "./InspectionReportDetails.vue?vue&type=template&id=65ed9e8b&"
import script from "./InspectionReportDetails.vue?vue&type=script&lang=js&"
export * from "./InspectionReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./InspectionReportDetails.vue?vue&type=style&index=0&id=65ed9e8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports